import { t } from '@hefe/i18n';
import { Inventory, InventoryCategory, SelectOption } from '@hefe/models';
import { ModalsSlice } from '@hefe/store';
import { DataNode } from 'antd/es/tree';
import InventoryDetailsComponent from '../components/inventory-details/inventory-details.component';

export const inventoryNavigationTreeData = (
  navigation: InventoryCategory[]
): DataNode[] => {
  const navigationNode = (category: InventoryCategory): DataNode => {
    return {
      title: category.name,
      key: category.id,
      children: category?.children?.map((child) => navigationNode(child)),
    } as DataNode;
  };

  const returnData = navigation?.map((category) => navigationNode(category));

  return [
    ...returnData,
    {
      title: t('inventory.categories.uncategorized'),
      key: 'uncategorized',
      checkable: false,
    },
  ];
};

export const inventoryNavigationTreeDataSelectOptions = (
  navigation: InventoryCategory[]
): SelectOption[] => {
  const navigationNode = (category: InventoryCategory): SelectOption => {
    return {
      label: category.name,
      value: category.id,
      children: category?.children?.map((child) => navigationNode(child)),
    } as SelectOption;
  };

  const returnData = navigation.map((category) => navigationNode(category));

  return [
    ...returnData,
    {
      label: t('inventory.categories.uncategorized'),
      value: 'uncategorized',
    },
  ];
};

export const openInventory = (inventory: Inventory, dispatch: any) => {
  dispatch(
    ModalsSlice.modalsActions.openModal({
      title: inventory.name,
      component: <InventoryDetailsComponent inventory={inventory} />,
      width: '90%',
      hideOkButton: true,
      hideCancelButton: true,
    })
  );
};
